<template>
  <div class="about_alliances" style="min-width:1440px;">
    <div class="second_banner animated fadeIn" style="height:400px">
      <!-- <img class="banner_img" src="../assets/img/union_banner.png" alt /> -->
      <!-- <img class="banner_img" src="../assets/img/union_banner.png" alt /> -->
      <img class="banner_img" :src="img.data.data.url" alt />
    </div>
    <div class="second_main animated fadeInUp" style="padding-left:20%;padding-right:20%">
      <div class="article" v-if="chOrEn!='0'" style="color:#24367D"><i class="el-icon-caret-right" style="font-size:24px;color:#24367D;"></i>论坛文章</div>
      <div class="article" v-else style="color:#24367D"><i class="el-icon-caret-right" style="font-size:24px;color:#24367D"></i>Forum Article</div>
      <div class="meeting_content_list" v-for="item in list.rows">
        <div class="ss" style="width:100%">
          <div class="meeting_content_listdiv" @click="toforumarticles2(item)" style="white-space:nowrap;text-overflow:ellipsis;-o-text-overflow:ellipsis;overflow: hidden;width:70%;height:100%">
            <!-- <el-tooltip placement="top">
              <div slot="content">多行信息<br/>{{item.title}}</div>
              <i class="el-icon-caret-right"></i>{{item.title}}
            </el-tooltip> -->
            <div>
              <el-tooltip :content="item.title" placement="top">
                <i style="font-size:18px;color:#2A303C;font-weight: bold;">{{item.title}} </i>
              </el-tooltip>
            </div>
          </div>
          <!-- <div @click="toforumarticles2(item)" class="meeting_content_listdiv"  style="color:#77818E;font-size:16px">{{item.createTime.substring(0,10)}}</div> -->
        </div>
        <div @click="toforumarticles2(item)" style="margin-top:12px;color:#77818E;margin-bottom:40px;font-size:14px">{{item.content}}<span v-if="item.content">...</span></div>
      </div>
      <!-- <div class="meeting_content_list">
        <div class="meeting_content_listdiv">从城市雕塑到公共艺术</div>
        <div class="meeting_content_listdiv">2017-05-20</div>
      </div>
      <div class="meeting_content_list">
        <div class="meeting_content_listdiv">建筑大师谈城市雕塑：如何更好的开展城市雕塑工作</div>
        <div class="meeting_content_listdiv">2017-05-20</div>
      </div>
      <div class="meeting_content_list">
        <div class="meeting_content_listdiv">刍议建设东北亚雕塑文化名城</div>
        <div class="meeting_content_listdiv">2017-05-20</div>
      </div>
      <div class="meeting_content_list">
        <div class="meeting_content_listdiv">刍议建设东北亚雕塑文化名城</div>
        <div class="meeting_content_listdiv">2017-05-20</div>
      </div>
      <div class="meeting_content_list">
        <div class="meeting_content_listdiv">刍议建设东北亚雕塑文化名城</div>
        <div class="meeting_content_listdiv">2017-05-20</div>
      </div>
      <div class="meeting_content_list">
        <div class="meeting_content_listdiv">从城市雕塑到公共艺术</div>
        <div class="meeting_content_listdiv">2017-05-20</div>
      </div>
      <div class="meeting_content_list">
        <div class="meeting_content_listdiv">建筑大师谈城市雕塑：如何更好的开展城市雕塑工作</div>
        <div class="meeting_content_listdiv">2017-05-20</div>
      </div>
      <div class="meeting_content_list">
        <div class="meeting_content_listdiv">刍议建设东北亚雕塑文化名城</div>
        <div class="meeting_content_listdiv">2017-05-20</div>
      </div> -->
      <!-- <div class="meeting_content_list">
        <div class="meeting_content_listdiv">刍议建设东北亚雕塑文化名城</div>
        <div class="meeting_content_listdiv">2017-05-20</div>
      </div> -->
      <div class="pagelist">
        <el-pagination
            background
            layout="prev, pager, next"
            :current-page.sync="currentPage"
            :total=num
            prev-text='上一页'
            next-text='下一页'
            @current-change="ok"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import videoPoster from "@/assets/img/meeting_video.png";
import { login,articlePage ,getByNav} from '../api/api'
import { Pagination,tooltip } from 'element-ui';
Vue.use(Pagination);
Vue.use(tooltip)

export default {
  name: "company",
  data() {
    return {
      chOrEn:sessionStorage.getItem('chOrEn'),
      currentPage:1,
      num:'',
      list:[],
      img:'',
    }
  },
  created(){
    this.button()
    let getBynavid = {
      navigationId:5
    }
    getByNav({...getBynavid}).then(res=>{
      this.img = res
    })
  },
  methods:{
    button(){
      let navigationId = {
        navigationId:5,
        page:this.currentPage,
        pageSize:10,
      }
      articlePage({...navigationId}).then(res=>{
        this.list=[]
        this.num = res.data.page.total
        this.list = res.data.page
      })
    },
    ok(val){
      let navigationId = {
        navigationId:5,
        page:val,
        pageSize:10,
      }
      articlePage({...navigationId}).then(res=>{
        this.list=[]
        this.list= res.data.page
      })
    },
    toforumarticles2(it){
      // let LoginParams = {
      //         username: 1111,
      //         password: 1111
      //       }
      // login({ ...LoginParams }).then(res => {
      //   console.log(res)
      // });
      this.$router.push({
        path: '/forumArticles/forumArticles2',
        query:{list: it.id,chOrEn:sessionStorage.getItem("chOrEn")}
        })
    }
  }
};
</script>

<style lang="less" scoped>
.banner_img{
  height: 400px;
}
.about_alliances {
  width: 100%;
//   height: 100%;
  /deep/ .el-tabs__item {
    // width: 200px;
    padding:0 10px!important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 20px;
  }
}
.second_main{
    position: relative;
    cursor:pointer;
}
.pagelist{
    position: absolute;
    display: inline-block;
    bottom: 51px;
    left: 50%;
    transform:translate(-50%,-50%);
}
.meeting_content_list{
  // height: 40px;
}
.ss{
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}
.meeting_content_listdiv{
  height: 18px;
  color: #2C2C2C;
  font-size: 18px;
  line-height: 40px;
  font-family: SourceHanSansCN-Light, SourceHanSansCN;
}
.article{
  color: #2033B3;
  font-size: 20px;
  font-weight: bold;
  padding-bottom: 9px;
  // border-bottom: 1px solid #2033b3;
  margin-bottom: 44px;
}
</style>